import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Tab, Tabs} from "react-bootstrap";

class TipEmailComponent extends Component {

    tipContent = () => {
        return (
            <div className="row">
                <div className="col-6">
                    <b>Gợi ý chung</b> <br/>
                    <div className="row">
                        <div className="col col-md-6">
                            User Name
                        </div>
                        <div className="col col-md-6">
                            {"{$user_name}"}
                        </div>
                        <div className="col col-md-6">
                            Email Address
                        </div>
                        <div className="col col-md-6">
                            {"{$user_email}"}
                        </div>
                        <div className="col col-md-6">
                            Url website
                        </div>
                        <div className="col col-md-6">
                            {"{$url}"}
                        </div>
                        <div className="col col-md-6">
                            Url control panel
                        </div>
                        <div className="col col-md-6">
                            {"{$url_control_panel}"}
                        </div>
                        <div className="col col-md-6">
                            Thời gian
                        </div>
                        <div className="col col-md-6">
                            {"{$time}"}
                        </div>
                    </div> <br/>
                    <b>Hosting</b> <br/>
                    <div className="row">
                        <div className="col col-md-6">
                            Domain
                        </div>
                        <div className="col col-md-6">
                            {"{$domain}"}
                        </div>
                        <div className="col col-md-6">
                            Cấu hình
                        </div>
                        <div className="col col-md-6">
                            {"{$service_config}"}
                        </div>
                        <div className="col col-md-6">
                            Tài khoản
                        </div>
                        <div className="col col-md-6">
                            {"{$services_username}"}
                        </div>
                        <div className="col col-md-6">
                            Mật khẩu
                        </div>
                        <div className="col col-md-6">
                            {"{$services_password}"}
                        </div>
                        <div className="col col-md-6">
                            Thời gian thuê
                        </div>
                        <div className="col col-md-6">
                            {"{$billing_cycle}"}
                        </div>
                        <div className="col col-md-6">
                            Ngày kết thúc
                        </div>
                        <div className="col col-md-6">
                            {"{$next_due_date}"}
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <b>Sản phẩm/Đặt hàng</b> <br/>
                    <div className="row">
                        <div className="col col-md-6">
                            Tên sản phẩm
                        </div>
                        <div className="col col-md-6">
                            {"{$product_name}"}
                        </div>
                        <div className="col col-md-6">
                            Giá sản phẩm
                        </div>
                        <div className="col col-md-6">
                            {"{$product_pricing}"}
                        </div>
                        <div className="col col-md-6">
                            Giá
                        </div>
                        <div className="col col-md-6">
                            {"{$sub_total}"}
                        </div>
                        <div className="col col-md-6">
                            Thành tiền
                        </div>
                        <div className="col col-md-6">
                            {"{$total}"}
                        </div>
                        <div className="col col-md-6">
                            Số lượng
                        </div>
                        <div className="col col-md-6">
                            {"{$qtt}"}
                        </div>
                        <div className="col col-md-6">
                            Thời gian tạo
                        </div>
                        <div className="col col-md-6">
                            {"{$order_created_at}"}
                        </div>
                    </div>
                    <br/>
                    <b>VPS - Proxy</b> <br/>
                    <div className="row">
                        <div className="col col-md-6">
                            IP
                        </div>
                        <div className="col col-md-6">
                            {"{$ip}"}
                        </div>
                        <div className="col col-md-6">
                            Port
                        </div>
                        <div className="col col-md-6">
                            {"{$port}"}
                        </div>
                        <div className="col col-md-6">
                            Cấu hình
                        </div>
                        <div className="col col-md-6">
                            {"{$vps_config}"}
                        </div>
                        <div className="col col-md-6">
                            Tài khoản
                        </div>
                        <div className="col col-md-6">
                            {"{$services_username}"}
                        </div>
                        <div className="col col-md-6">
                            Mật khẩu
                        </div>
                        <div className="col col-md-6">
                            {"{$services_password}"}
                        </div>
                        <div className="col col-md-6">
                            Thời gian thuê
                        </div>
                        <div className="col col-md-6">
                            {"{$billing_cycle}"}
                        </div>
                        <div className="col col-md-6">
                            Ngày kết thúc
                        </div>
                        <div className="col col-md-6">
                            {"{$next_due_date}"}
                        </div>
                        <div className="col col-md-6">
                            Hệ điều hành
                        </div>
                        <div className="col col-md-6">
                            {"{$os}"}
                        </div>
                        <div className="col col-md-6">
                            Bang
                        </div>
                        <div className="col col-md-6">
                            {"{$state}"}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    tipSubject = () => {
        return (
            <>
                <h4>Gợi ý chung</h4>
                <div className="row">
                    <div className="col-4">
                        <b>IP của VPS</b>
                    </div>
                    <div className="col-6">
                        {'{$vps_ip}'}
                    </div>
                    <div className="col-4">
                        <b>Port</b>
                    </div>
                    <div className="col-6">
                        {'{$port}'}
                    </div>
                </div>
            </>
        )
    }

    render() {
        return (
            <Row className={'system-email-tips'}>
                <Col>
                    <Card>
                        <CardHeader className={'font-weight-bold'}>
                            Gợi ý chèn mã dữ liệu vào email
                        </CardHeader>
                        <CardBody>
                            <Tabs defaultActiveKey="home" id="uncontrolled-tab-example" className="mb-3">
                                <Tab eventKey="home" title="Nội dung">
                                    { this.tipContent() }
                                </Tab>
                                <Tab eventKey="profile" title="Tiêu đề">
                                    { this.tipSubject() }
                                </Tab>
                            </Tabs>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }
}

export default TipEmailComponent;